<div class="main">
  <div style="position: relative" *ngIf="!hasLocation">No location data available for this inspection.</div>

  <div style="height: 600px">
    <app-mapbox
      (load)="setMap($event)"
      [minZoom]="15"
      (scoreCheckerChanged)="scoreChanged($event)"
      [showFlagScoreContainer]="true"></app-mapbox>
  </div>
</div>

<div #popupContainer class="popup-container">
  <div *ngIf="popup" xmlns="http://www.w3.org/1999/html">
    <div class="popup-rows">
      <span>Item:</span>
      <span> {{ popup.item }}</span>
    </div>
    <div class="popup-rows">
      <span>Section:</span>
      <span>{{ popup.section }}</span>
    </div>
    <div class="popup-rows">
      <span>Question: </span> &nbsp;
      <span style="color: #3465c4; font-weight: bold; cursor: pointer" (click)="gotoQuestion(selectedAnswer)">
        {{ popup.question }}</span
      >
      <span style="width: 5%; text-align: right">
        <i
          class="fa fa-chevron-right"
          (click)="gotoQuestion(selectedAnswer)"
          style="color: #3465c4; cursor: pointer"></i>
      </span>
    </div>
    <div class="location">({{ popup.center[1].toFixed(6) }}, {{ popup.center[0].toFixed(6) }})</div>

    <div class="view-gallery" *ngIf="!showItemGallery">
      <i class="fa fa-external-link" (click)="toggleItemGallery()"></i>
      <span (click)="toggleItemGallery()">Show gallery for the same item</span>
    </div>

    <div class="show-gallery" *ngIf="showItemGallery">
      <ngx-gallery
        *ngIf="popup.itemImages.length > 0"
        [options]="galleryOptions"
        [images]="popup.itemImages"></ngx-gallery>
      <div *ngIf="popup.itemImages.length === 0">No images for the same item</div>
      <span *ngIf="popup.itemImages.length > 0" (click)="setItem(selectedAnswer); gotoGallery()">View Gallery </span>
      <i
        class="fa fa-chevron-right"
        *ngIf="popup.itemImages.length > 0"
        (click)="setItem(selectedAnswer); gotoGallery()"></i>
    </div>

    <div class="view-gallery" *ngIf="!showSectionGallery">
      <i class="fa fa-external-link" (click)="toggleSectionGallery()"></i>
      <span (click)="toggleSectionGallery()">Show gallery for the same section</span>
    </div>

    <div class="show-gallery" *ngIf="showSectionGallery">
      <ngx-gallery
        *ngIf="popup.sectionImages.length > 0"
        [options]="galleryOptions"
        [images]="popup.sectionImages"></ngx-gallery>
      <div *ngIf="popup.sectionImages.length === 0">No images for the same item</div>
      <span *ngIf="popup.sectionImages.length > 0" (click)="setSection(selectedAnswer); gotoGallery()"
        >View Gallery
      </span>
      <i
        class="fa fa-chevron-right"
        *ngIf="popup.sectionImages.length > 0"
        (click)="setSection(selectedAnswer); gotoGallery()"></i>
    </div>
  </div>
</div>
